import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { loadTrackers, setConsent, shouldShowBanner } from "@/lib/consent";

// Only renders for visitors in the EU/EEA/UK who have not answered yet. Everyone else never
// sees it — see src/lib/consent.js for why that split exists.
export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(shouldShowBanner());
  }, []);

  const decide = (value) => {
    setConsent(value);
    setVisible(false);
    if (value === "granted") loadTrackers();
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[70] border-t border-white/10 bg-[#0a0a0a] px-4 py-4 sm:px-6"
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-banner"
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-orange-500" />
          <p className="text-xs leading-relaxed text-zinc-400 sm:text-[13px]">
            We use analytics cookies to see which pages actually help people and whether our ads
            are worth running. Decline and we load none of it — the site works exactly the same.{" "}
            <Link to="/privacy" className="text-orange-500 underline underline-offset-4 hover:text-orange-400">
              Privacy Policy
            </Link>
          </p>
        </div>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={() => decide("denied")}
            className="border border-white/15 px-5 py-2.5 text-[11px] font-black uppercase tracking-[0.2em] text-zinc-300 transition-colors hover:border-white/30 hover:text-white"
            data-testid="cookie-decline"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={() => decide("granted")}
            className="bg-orange-500 px-5 py-2.5 text-[11px] font-black uppercase tracking-[0.2em] text-black transition-colors hover:bg-orange-400"
            data-testid="cookie-accept"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};
